import { useExperimentTreatmentWithoutReporting } from '@ms/yammer-hooks/dist/experiments';

import { UseUIFeatureCheck } from '../types';

export const useIsNetworkThemesEnabled: UseUIFeatureCheck = () =>
  useExperimentTreatmentWithoutReporting('VivaEngageGlobalCopilot') === true;
